import reducer from './reducer';
import * as actions from './actions';

const STATE_KEY = 'recipe';

export { STATE_KEY, reducer, actions };